import { FLAGS, useFlag } from '@iheartjane/feature-flags';

import type { MenuRow } from '@jane/business-admin/types';

/**
 * Hook that returns a function to get the appropriate row type value
 * based on the menu row type feature flag.
 * @returns An object with:
 *   - getRowType: A function that takes a MenuRow and returns either menu_row_type or row_type
 *   - useMenuRowType: The boolean flag value for conditional logic
 */
export const useMenuRowType = () => {
  const useMenuRowTypeFlag = useFlag(FLAGS.cnMenuRowTypeFe);

  const getRowType = (
    row: MenuRow | { menu_row_type?: string; row_type?: string }
  ) => {
    return useMenuRowTypeFlag ? row.menu_row_type : row.row_type;
  };

  return {
    getRowType,
    useMenuRowType: useMenuRowTypeFlag,
  };
};
